import { render, staticRenderFns } from "./Complain.vue?vue&type=template&id=4ea1db82&scoped=true&lang=pug"
import script from "./Complain.vue?vue&type=script&lang=js"
export * from "./Complain.vue?vue&type=script&lang=js"
import style0 from "./Complain.vue?vue&type=style&index=0&id=4ea1db82&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea1db82",
  null
  
)

export default component.exports